<mat-sidenav-container class="fc-mobile-menu-wrapper">
    <mat-sidenav (closed)="closeMenu()" #mobileMenu mode="over" class="fc-mobile-menu-drawer">
        <div class="fc-mobile-menu">
            <button
                *ngLet="showSecondaryMenu | async as isSecondaryMenuVisible"
                fcp-outlined-button
                (click)="isSecondaryMenuVisible ? goBackToMainMenu() : mobileMenu.toggle()"
                color="transparent"
                class="fc-mobile-menu-trigger"
            >
                <i class="fc-font-icon fc-font-icon-arrow-left fc-platform-navigation-action"></i>
            </button>

            <nav class="fc-mobile-menu-list-wrapper">
                <ul class="fc-mobile-menu-list">
                    <a
                        *ngFor="let item of visibleMenuList | async"
                        [routerLink]="item?.route?.target"
                        routerLinkActive="fc-mobile-menu-list-item--active"
                        [queryParams]="item?.route?.queryParams"
                        [queryParamsHandling]="item?.route?.queryParamsHandling"
                        [routerLinkActiveOptions]="
                            item?.route?.routerLinkActiveOptions || {
                                queryParams: 'ignored',
                                matrixParams: 'exact',
                                paths: 'subset',
                                fragment: 'exact'
                            }
                        "
                        (isActiveChange)="onMenuActiveChange(item)"
                        class="fc-mobile-menu-list-item"
                        (click)="onMenuItemClick(item)"
                        [showForUserPrivileges]="item.privileges"
                    >
                        {{ item.label | translate }}
                        <i *ngIf="item.hasChildren" class="fc-font-icon fc-font-icon-arrow-right"></i>
                    </a>
                </ul>
            </nav>

            <nav *ngIf="!(showSecondaryMenu | async)" class="fc-mobile-menu-actions">
                <hr class="fc-mobile-menu-actions-divider" />
                <ul class="fc-mobile-menu-list">
                    <li class="fc-mobile-menu-list-item" (click)="openSettings()">
                        {{ 'NAV_BAR.SETTINGS' | translate }}
                        <i class="fc-font-icon fc-font-icon-arrow-right"></i>
                    </li>
                    <!-- TODO: translation key and open Intercom action -->
                    <!--                    <li class="fc-mobile-menu-list-item">-->
                    <!--                        {{ 'Support' | translate }}-->
                    <!--                    </li>-->
                    <a
                        href="https://help.fashion.cloud/{{ languageService.getFAQLanguage() }}/"
                        target="_blank"
                        class="fc-mobile-menu-list-item"
                    >
                        {{ 'FAQ_LINK.TITLE' | translate }}
                    </a>
                    <li (click)="logout()" class="fc-mobile-menu-list-item">
                        {{ 'LOGOUT_BUTTON.TITLE' | translate }}
                    </li>
                </ul>
            </nav>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <ng-content></ng-content>
    </mat-sidenav-content>
</mat-sidenav-container>
